<ng-container *ngIf="withPrefix" [ngTemplateOutlet]="content"></ng-container>
<mat-form-field appearance="outline" [ngClass]="appClass"
                class="max-width {{ validations.valid ? 'no-hint' : 'field-error responsive-hint' }}
                                 {{ withSuffix ? 'with-suffix' : '' }}
                                 {{ withPrefix ? 'with-prefix' : '' }}
                                 {{ small ? 'small' : '' }}"
                (focusin)="utilService.mobileFocus($event.target)">
  <mat-label *ngIf="label">{{ label | translate }}</mat-label>
  <input matInput type="text" [name]="name"
         [placeholder]="placeholder ? placeholder : ((type === NumericInputType.Percentage && withLinkButton && !hideSymbol) ? '%' : null)"
         [(ngModel)]="value" [ngModelOptions]="{standalone: true}" (ngModelChange)="changeValue()"
         (keyup)="inputKeyup.emit($event)" (focus)="inputFocused($event)" (blur)="inputBlurred($event)"
         [required]="required" [disabled]="disabled" autocomplete="off">
  <span matTextSuffix *ngIf="[NumericInputType.Price, NumericInputType.Percentage].includes(type) && !hideSymbol && !withLinkButton">
    {{ type === NumericInputType.Price ? authService.currencySymbol : '%' }}
  </span>
  <a matSuffix class="link" *ngIf="withLinkButton" (click)="$event.stopPropagation(); linkButtonClicked.emit()" [attr.aria-disabled]="disabled">
    <span>{{ linkButtonText | translate }}</span>
  </a>
  <ng-container *ngIf="withLinkButton" [ngTemplateOutlet]="content"></ng-container>
  <mat-hint class="text-warning" *ngIf="!validations.valid">
    <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
    <ng-container *ngIf="hasCustomError">{{ customError | translate }}</ng-container>
    <ng-container *ngIf="!hasCustomError">
      {{ (validations.tooBig ? 'general.api_validation_digits_too_large' :
          (validations.tooSmall ? 'general.api_validation_digits_too_small' :
            (type === NumericInputType.Price ? 'general.api_validation_price_invalid' :
              (type === NumericInputType.Percentage ? (allowPercentageDecimalPlaces ? 'general.api_validation_percentage_decimal_invalid' : 'general.api_validation_percentage_invalid') :
                'general.api_validation_only_digits')))) | translate }}
    </ng-container>
  </mat-hint>
</mat-form-field>
<ng-container *ngIf="withSuffix" [ngTemplateOutlet]="content"></ng-container>
<ng-template #content><ng-content></ng-content></ng-template>
